import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyInjury = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 12H20.467C21.419 10.938 22 9.536 22 8C22 4.691 19.308 2 16 2C12.692 2 10 4.691 10 8C10 9.536 10.581 10.938 11.533 12H11C8.243 12 6 14.243 6 17V23.005V24.999C6 27.756 8.243 29.999 11 29.999H21C23.757 29.999 26 27.756 26 24.999V16.999C26 14.242 23.757 11.999 21 11.999V12ZM12 8C12 5.794 13.794 4 16 4C18.206 4 20 5.794 20 8C20 10.206 18.206 12 16 12C13.794 12 12 10.206 12 8ZM11 14H16.238L8 20.865V17C8 15.346 9.346 14 11 14ZM8 25V23.468L19.362 14H21C21.824 14 22.571 14.334 23.113 14.873L10.599 27.972C9.134 27.775 8 26.518 8 25ZM18 24C19.103 24 20 24.897 20 26C20 27.103 19.103 28 18 28H13.338L17.159 24H17.999H18ZM24 25C24 26.489 22.909 27.728 21.485 27.96C21.813 27.38 22 26.712 22 26C22 24.125 20.703 22.548 18.959 22.117L23.996 16.844C23.999 16.896 24 16.947 24 17V25Z" />
	</svg>
);

export default SafetyInjury;
